'use strict';

var _ = require('lodash');
var FaresOptimizerSharedFbcService = function FaresOptimizerSharedFbcService(FaresOptimizerConstants, momentService) {
  function getLadderDetails(data, rawData, recalculatedLadder) {
    var ladderIds = _.union(_.chain(data).map('fareRecommendationRecordKey').flatten().uniq().value(), _.chain(data).map('allSharedFbcLadderIds').flatten().uniq().value());
    return _.chain(ladderIds).filter(function (ladderId) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      });
      return isLadderApprovable(ladder) || isRecalculatedLadderApprovable(ladder, recalculatedLadder);
    }).value();
  }
  function isRecalculatedLadderApprovable(ladder, recalculatedLadder) {
    return !_.isNil(recalculatedLadder) && ladder.fareRecommendationRecordKey === recalculatedLadder.fareRecommendationRecordKey && isLadderApprovable(recalculatedLadder);
  }
  function getLadderDetailsForApproval(data, rawData, recalculatedLadder) {
    var ladderIds = getLadderDetails(data, rawData, recalculatedLadder);
    return _.chain(ladderIds).map(function (ladderId) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      });
      return {
        ladderId: ladderId,
        fbc: ladder.fbc.replace(ladder.fbc.charAt(0), '*'),
        hasSharedFbc: ladder.allSharedEntryLevelFbcList.length >= 1
      };
    }).value();
  }
  function getSharedEntryLevelFbcs(data, allRows) {
    var allSharedEntryLevelFbcList = _.chain(data).flatMap('allSharedEntryLevelFbcList').uniq().value();
    var laddersWithSharedFbc = getLaddersWithSharedFbc(data, allRows);
    var filteredFbcList = getFilteredFbcs(laddersWithSharedFbc, allSharedEntryLevelFbcList);
    return _.chain(filteredFbcList).map(function (fbc) {
      return fbc.replace(fbc.charAt(0), '*');
    }).value();
  }
  function getLaddersWithSharedFbc(data, allRows) {
    var applicableLadders = [];
    _.forEach(data, function (ladder) {
      applicableLadders.push.apply(applicableLadders, getApprovableLadders(ladder, allRows));
    });
    return applicableLadders;
  }
  function getFilteredFbcs(allRows, fbcList) {
    var filteredFbcList = [];
    var filteredData = _.filter(allRows, isLadderApprovable);
    _.forEach(fbcList, function (fbc) {
      var ladder = _.find(filteredData, {
        'fbc': fbc
      });
      if (!_.isNil(ladder)) {
        filteredFbcList.push(fbc);
      }
    });
    return filteredFbcList;
  }
  function getApprovableLadders(data, rawData) {
    var ladderIds = _.union(_.map([data], 'fareRecommendationRecordKey'), data.allSharedFbcLadderIds);
    return _.chain(ladderIds).map(function (ladderId) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      });
      if (isLadderApprovable(ladder)) {
        return ladder;
      }
    }).without(undefined).value();
  }
  function isApprovedLadderWithFutureEffectiveDate(ladder) {
    return ladder.status === FaresOptimizerConstants.APPROVED && ladder.recommendationEffectiveDate.isAfter(getTodaysDate());
  }
  function getTodaysDate() {
    var momentConfig = momentService.ruleTypeToConfig('utc2date');
    return _.isUndefined(momentConfig) ? '' : momentService.systemNow(momentConfig).startOf('day');
  }
  function isLadderApprovable(row) {
    return !_.isNil(row) && (row.status === FaresOptimizerConstants.NEW || row.status === FaresOptimizerConstants.PENDING || isApprovedLadderWithFutureEffectiveDate(row));
  }
  return {
    getSharedEntryLevelFbcs: getSharedEntryLevelFbcs,
    getLadderDetailsForApproval: getLadderDetailsForApproval
  };
};
FaresOptimizerSharedFbcService.$inject = ['FaresOptimizerConstants', 'MomentService'];
module.exports = FaresOptimizerSharedFbcService;